// app/components/Popup.tsx (Server Component)
import React from 'react';
import PopupClient from './PopupClient';

type PopupAPIResponse = {
  success: boolean;
  data?: {
    imageUrl: string;
    title: string;
    description: string;
    promocode: string;
    active: boolean;
  };
  message?: string;
};

async function fetchPopupData(): Promise<PopupAPIResponse> {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000";
  const apiUrl = `${baseUrl}/api/popup`;
  const res = await fetch(apiUrl, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Failed to fetch popup data: ${res.statusText}`);
  }
  return res.json();
}

export default async function Popup() {
  let popupData: PopupAPIResponse | null = null;
  try {
    popupData = await fetchPopupData();
  } catch (err) {
    console.error("Failed to fetch popup data:", err);
    return null;
  }
  
  // Only render if active is true
  if (!popupData?.success || !popupData?.data || popupData.data.active !== true) {
    return null;
  }
  
  return (
    <PopupClient
      popupData={{
        imageUrl: popupData.data.imageUrl,
        title: popupData.data.title,
        description: popupData.data.description,
        promocode: popupData.data.promocode,
        active: popupData.data.active,
      }}
    />
  );
}
